import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { Dialog } from "material-ui";

import CheckCircleIcon from "material-ui/svg-icons/action/check-circle";
import { green500 } from "material-ui/styles/colors";

import config from "../../../config";
import { formatPrice } from "../../../util";

import LikeLike from "../link-like.jsx";

import UserStore from "../../../stores/UserStore";

const CONTAINER_STYLE = {
  border: "1px solid #0288d1",
  padding: 10,
  marginBottom: 10,
  textAlign: "center"
};

class BoxOfficeLastOrder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopover: false
    };

    this._closePopover = this._closePopover.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.lastOrder && newProps.lastOrder !== this.props.lastOrder) {
      clearTimeout(this.timeout);
      this.setState({ showPopover: true }, () => {
        this.timeout = setTimeout(this._closePopover, 3500);
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  _closePopover() {
    this.setState({ showPopover: false });
  }

  render() {
    let { lastOrder, repeatLastOrder } = this.props,
      { showPopover } = this.state;

    return (
      <div>
        <Dialog
          open={showPopover && !!lastOrder}
          onRequestClose={this._closePopover}
        >
          {lastOrder ? (
            <div style={{ cursor: "pointer" }} onClick={this._closePopover}>
              <CheckCircleIcon
                color={green500}
                style={{
                  display: "block",
                  width: 75,
                  height: 75,
                  margin: "0 auto 0.5em"
                }}
              />
              <div
                style={{
                  fontSize: "1.25em",
                  textAlign: "center",
                  lineHeight: 1.5
                }}
              >
                Order placed successfully.
                <br />
                {formatPrice(lastOrder.purchase_price)} •{" "}
                {moment(lastOrder.created_at).format("LLLL")}
              </div>
            </div>
          ) : null}
        </Dialog>
        {lastOrder ? (
          <div style={CONTAINER_STYLE}>
            <span>
              Last order:{" "}
              <strong>{formatPrice(lastOrder.purchase_price)}</strong> •{" "}
              {moment(lastOrder.created_at).format("LLLL")}
              {lastOrder.tickets.length ? (
                <span>
                  {" "}
                  •{" "}
                  <a
                    href={
                      config.endpoint +
                      lastOrder.order_tickets_pdf_path +
                      "?via_box_office=true"
                    }
                    target="_blank"
                  >
                    Open tickets PDF
                  </a>
                </span>
              ) : null}
              {lastOrder.passes.length ? (
                <span>
                  {" "}
                  •{" "}
                  <a
                    href={
                      config.endpoint +
                      `passes/labels.pdf?${UserStore.makeApiKeyQueryString()}&conditions=${JSON.stringify(
                        { _id: { $in: lastOrder.passes.map(p => p.id) } }
                      )}`
                    }
                    target="_blank"
                  >
                    Open pass labels PDF
                  </a>
                </span>
              ) : null}
              <span>
                {" "}
                •{" "}
                <a
                  href={config.endpoint + `orders/${lastOrder.id}/receipt.pdf`}
                  target="_blank"
                >
                  Open receipt PDF
                </a>
              </span>
              <span>
                {" "}
                • 
                <Link
                  to={`/event_buckets/${lastOrder.event_bucket.id}/orders/${lastOrder.id}`}
                >
                  View order
                </Link>
              </span>
              <span>
                {" "}
                • <LikeLike onTouchTap={repeatLastOrder}>Repeat order</LikeLike>
              </span>
            </span>
          </div>
        ) : null}
      </div>
    );
  }
}

export default BoxOfficeLastOrder;



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-last-order.jsx